import type { ChangeStatusDrawerInfo } from "../../hoc/withDrawers";
import ActualNumberOfSkips from "../extra-fields/ActualNumberOfSkips";
import ActualQuantityField from "../extra-fields/ActualQuantityField";
import ATCField from "../extra-fields/ATCField";
import ATSField from "../extra-fields/ATSField";
import ETCField from "../extra-fields/ETCField";
import ExternalNotesAndAttachmentsComponent from "../extra-fields/ExternalNotesAndAttachments";
import GarbageDisposalDocument from "../extra-fields/GarbageDisposalDocument";
import InternalNotesAndAttachmentsComponent from "../extra-fields/InternalNotesAndAttachments";
import RejectionReasonAndAttachment from "../extra-fields/RejectionReasonAndAttachment";

interface ExtraFieldProps {
  serviceDetails: ChangeStatusDrawerInfo;
}

const extraFieldsMap = {
  internalNotes: () => <InternalNotesAndAttachmentsComponent />,
  externalNotes: () => <ExternalNotesAndAttachmentsComponent />,
  rejectionReason: () => <RejectionReasonAndAttachment />,
  ats: (props: ExtraFieldProps) => <ATSField {...props} />,
  etc: (props: ExtraFieldProps) => <ETCField {...props} />,
  atc: (props: ExtraFieldProps) => <ATCField {...props} />,
  actualQuantity: (props: ExtraFieldProps) => <ActualQuantityField {...props} />,
  actualNumberOfSkips: (props: ExtraFieldProps) => <ActualNumberOfSkips {...props} />,
  garbageDisposalDocument: () => <GarbageDisposalDocument />,
};

type GarbageExtraFieldsProps = {
  currentFlowStep: any;
  selectedStatus: string;
} & ExtraFieldProps;

const GarbageExtraFields = ({
  currentFlowStep,
  selectedStatus,
  ...restProps
}: GarbageExtraFieldsProps) => {
  return (
    <div className="flex flex-col gap-2">
      {currentFlowStep?.statusesList?.[selectedStatus]?.extraFields?.length
        ? currentFlowStep.statusesList[selectedStatus].extraFields.map(
            (field: keyof typeof extraFieldsMap) => {
              const FieldComponent = extraFieldsMap[field];

              if (!FieldComponent) return null;

              return (
                <div className="mt-4" key={field}>
                  <FieldComponent {...restProps} />
                </div>
              );
            },
          )
        : null}
    </div>
  );
};

export default GarbageExtraFields;
